/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AccessoryRegistration from '../components/AccessoryRegistration';
import AccessoryRegistrationReview from '../components/AccessoryRegistrationReview';
import Accordion from '../components/Accordion';
import AccountInviteModal from '../components/AccountInviteModal';
import AddCarer from '../components/AddCarer';
import AmazonConnectChat from '../components/AmazonConnectChat';
import AssignLoaner from '../components/AssignLoaner';
import AssignLoanerDetails from '../components/AssignLoanerDetails';
import AssociationSpinner from '../components/AssociationSpinner';
import AsyncNotificationWidget from '../components/AsyncNotificationWidget';
import ClinicEquipment from '../components/ClinicEquipment';
import ClinicSyncFrame from '../components/ClinicSyncFrame';
import ClinicianManagement from '../components/ClinicianManagement';
import ContactDetails from '../components/ContactDetails';
import ContentBlock from '../components/ContentBlock';
import CpnResource from '../components/CpnResource';
import CreatePatientCarer from '../components/CreatePatientCarer';
import CreatePatientLanding from '../components/CreatePatientLanding';
import CreatePatientRecipient from '../components/CreatePatientRecipient';
import CreateServiceRequest from '../components/CreateServiceRequest';
import CustomerContactModal from '../components/CustomerContactModal';
import DetailActionBar from '../components/DetailActionBar';
import DetailsView from '../components/DetailsView';
import DeviceRegistration from '../components/DeviceRegistration';
import DeviceRegistrationReview from '../components/DeviceRegistrationReview';
import DeviceRegistrationSuccess from '../components/DeviceRegistrationSuccess';
import DisabledFeature from '../components/DisabledFeature';
import EditPatient from '../components/EditPatient';
import Error from '../components/Error';
import FeatureVersion from '../components/FeatureVersion';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HeaderNew from '../components/HeaderNew';
import LocatePatient from '../components/LocatePatient';
import MainContentBlock from '../components/MainContentBlock';
import MarkDeceasedModal from '../components/MarkDeceasedModal';
import MyAccount from '../components/MyAccount';
import MyProfile from '../components/MyProfile';
import OnboardingQRCode from '../components/OnboardingQRCode';
import OptionalEmail from '../components/OptionalEmail';
import PatientRecord from '../components/PatientRecord';
import Patients from '../components/Patients';
import PersonalDetails from '../components/PersonalDetails';
import ProgrammingFileRequests from '../components/ProgrammingFileRequests';
import RegistrationModal from '../components/RegistrationModal';
import ReportLoanerIssue from '../components/ReportLoanerIssue';
import ResourcePage from '../components/ResourcePage';
import ResourcePageLanding from '../components/ResourcePageLanding';
import Resources from '../components/Resources';
import SRPortalHome from '../components/SRPortalHome';
import Search from '../components/Search';
import SelectClinic from '../components/SelectClinic';
import SingleTabView from '../components/SingleTabView';
import TeamMembers from '../components/TeamMembers';
import UpdateAccessoryModal from '../components/UpdateAccessoryModal';
import ViewServiceRequest from '../components/ViewServiceRequest';

const components = new Map();
components.set('AccessoryRegistration', AccessoryRegistration);
components.set('AccessoryRegistrationReview', AccessoryRegistrationReview);
components.set('Accordion', Accordion);
components.set('AccountInviteModal', AccountInviteModal);
components.set('AddCarer', AddCarer);
components.set('AmazonConnectChat', AmazonConnectChat);
components.set('AssignLoaner', AssignLoaner);
components.set('AssignLoanerDetails', AssignLoanerDetails);
components.set('AssociationSpinner', AssociationSpinner);
components.set('AsyncNotificationWidget', AsyncNotificationWidget);
components.set('ClinicEquipment', ClinicEquipment);
components.set('ClinicSyncFrame', ClinicSyncFrame);
components.set('ClinicianManagement', ClinicianManagement);
components.set('ContactDetails', ContactDetails);
components.set('ContentBlock', ContentBlock);
components.set('CpnResource', CpnResource);
components.set('CreatePatientCarer', CreatePatientCarer);
components.set('CreatePatientLanding', CreatePatientLanding);
components.set('CreatePatientRecipient', CreatePatientRecipient);
components.set('CreateServiceRequest', CreateServiceRequest);
components.set('CustomerContactModal', CustomerContactModal);
components.set('DetailActionBar', DetailActionBar);
components.set('DetailsView', DetailsView);
components.set('DeviceRegistration', DeviceRegistration);
components.set('DeviceRegistrationReview', DeviceRegistrationReview);
components.set('DeviceRegistrationSuccess', DeviceRegistrationSuccess);
components.set('DisabledFeature', DisabledFeature);
components.set('EditPatient', EditPatient);
components.set('Error', Error);
components.set('FeatureVersion', FeatureVersion);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('HeaderNew', HeaderNew);
components.set('LocatePatient', LocatePatient);
components.set('MainContentBlock', MainContentBlock);
components.set('MarkDeceasedModal', MarkDeceasedModal);
components.set('MyAccount', MyAccount);
components.set('MyProfile', MyProfile);
components.set('OnboardingQRCode', OnboardingQRCode);
components.set('OptionalEmail', OptionalEmail);
components.set('PatientRecord', PatientRecord);
components.set('Patients', Patients);
components.set('PersonalDetails', PersonalDetails);
components.set('ProgrammingFileRequests', ProgrammingFileRequests);
components.set('RegistrationModal', RegistrationModal);
components.set('ReportLoanerIssue', ReportLoanerIssue);
components.set('ResourcePage', ResourcePage);
components.set('ResourcePageLanding', ResourcePageLanding);
components.set('Resources', Resources);
components.set('SRPortalHome', SRPortalHome);
components.set('Search', Search);
components.set('SelectClinic', SelectClinic);
components.set('SingleTabView', SingleTabView);
components.set('TeamMembers', TeamMembers);
components.set('UpdateAccessoryModal', UpdateAccessoryModal);
components.set('ViewServiceRequest', ViewServiceRequest);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
